const pathToRegexp = require('path-to-regexp')

module.exports = (route, options) => {
  const toPath = pathToRegexp.compile(route)
  return toPath(options)
}
